/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbPostRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbConfigReferenceTypeUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbConfigReferenceTypeUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { ReferenceType, ActionApi } from './ActionApi.types.tsx';

type RequestBodyType = {
	displayName?: string;
	name: string;
	description: string;
	color: string;
};

export const createReferenceType =
	(data: RequestBodyType): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		setState({
			...state,
			referenceTypes: { ...state.referenceTypes, createLoading: true },
		});

		try {
			const response: ReferenceType = await performCmdbPostRequest(
				getCmdbConfigReferenceTypeUrl(workspaceId),
				{ body: JSON.stringify({ ...data, color: data.color.replace('#', '') }) },
			);

			setState({
				...state,
				referenceTypes: {
					...state.referenceTypes,
					createLoading: false,
					data: [...(state.referenceTypes.data ?? []), response],
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'createReferenceType succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...state,
				referenceTypes: {
					...state.referenceTypes,
					createLoading: false,
					createError: error,
				},
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'createReferenceType',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error,
			});

			throw error;
		}
	};
